import { render, staticRenderFns } from "./section-form.vue?vue&type=template&id=40238c16&scoped=true"
import script from "./section-form.vue?vue&type=script&lang=ts"
export * from "./section-form.vue?vue&type=script&lang=ts"
import style0 from "./section-form.vue?vue&type=style&index=0&id=40238c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40238c16",
  null
  
)

export default component.exports